/**
 * Shared authentication constants
 */
export const CLIENT_ID = 'website';
